import {RouteConfig} from "vue-router";
const Whitelist = () => import('../views/whitelist/Whitelist.vue');
const WhitelistMinecraft = () => import('../views/whitelist/WhitelistMinecraft.vue');
const WhitelistMinecraft2 = () => import('../views/whitelist/WhitelistMinecraft2.vue');
const WhitelistAltV = () => import('../views/whitelist/WhitelistAltV.vue');

let whitelist: RouteConfig[] = [
    {
        name: 'whitelist',
        path: '/whitelist',
        component: Whitelist,
        redirect: {name: 'whitelist-minecraft'},
        children: [
            {
                name: 'whitelist-altv',
                path: '/whitelist/altv',
                component: WhitelistAltV,
                meta: {
                    allowLoggedOut: true,
                },
            },
            {
                name: 'whitelist-minecraft',
                path: '/whitelist/minecraft',
                component: WhitelistMinecraft,
                meta: {
                    allowLoggedOut: true,
                },
            },
            {
                name: 'whitelist-minecraft2',
                path: '/whitelist/minecraft2',
                component: WhitelistMinecraft2,
                meta: {
                    allowLoggedOut: true,
                },
            }
        ]
    },
];

export default whitelist;
